<div class="section" *ngIf="editModeSet || business.unicomFreq || business.arincFreq || hasTag(business.tags,'Monitor CTAF')">
  <div class="section__header">
    <h2 class="section__header-text">Communication Frequencies
      <mat-icon (click)="openEditCommunicationsDialog()" *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
    </h2>
  </div>
  <div class="section__body">
    <div class="data-block data-block--shaded-labels">
      <div class="data-block__item">
        <div class="data-block__label">Unicom Frequency</div>
        <div class="data-block__value">
          <span *ngIf="business.unicomFreq; else noneReportedPlaceholder">
            {{ business.unicomFreq | frequency }}
          </span>
        </div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">ASRI Frequency <span class="data-block__label-supp">(ARINC)</span></div>
        <div class="data-block__value">
          <span *ngIf="business.arincFreq; else noneReportedPlaceholder">
            {{ business.arincFreq | frequency }}
          </span>
        </div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">Monitoring Airport CTAF</div>
        <div class="data-block__value">
          <span *ngIf="hasTag(business.tags,'Monitor CTAF'); else noPlaceholder">Yes</span>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #placeholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">There are no contacts currently listed for this business.</div>
  </div>
</ng-template>
<ng-template #noneReportedPlaceholder>
  <span class="na">None reported</span>
</ng-template>
<ng-template #noPlaceholder>
  <span class="na">No</span>
</ng-template>
<ng-template #na>
  <span class="na">N/A</span>
</ng-template>
